module.exports = __webpack_public_path__ + "static/adeniyi-03e06fc66beb9715000fd5d526e1efba.jpg";